<div mdbModal style="overflow-y: auto;" #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog" role="document">
    <form autocomplete="off" [formGroup]="formHeader">
      <div class="modal-content">
        <div class="modal-header">
          <h4 *ngIf="mode==='ADD'" class="modal-title w-100 text-left" id="myModalLabel">
            Agregar
          </h4>
          <h4 *ngIf="mode==='EDIT'" class="modal-title w-100 text-left" id="myModalLabel">
            Editar
          </h4>
          <h4 *ngIf="mode==='VIEW'" class="modal-title w-100 text-left" id="myModalLabel">
            Ver
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row" style="border-bottom: 1px solid #dee2e6;">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de proveedor
              </h5>
            </div>
            <div class="col">
              <div class="switch info-switch" formGroupName="basicos">
                <label>
                  Inactivo
                  <input type="checkbox" color="info" checked formControlName="activo" />
                  <span class="lever"></span> Activo
                </label>
              </div>
            </div>
          </div>

          <div class="row" formGroupName="basicos">
            <div class="col">
              <div class="md-form">
                <input placeholder="RUT" class="form-control" type="text" id="provrut" formControlName="rut" formatRut
                  maxLength="10" required #provrut />
                <label for="provrut">RUT
                  <span class="required-asterisk">*</span>
                </label>
                <div *ngIf="
                                    formHeader.get('basicos.rut').invalid &&
                                    (formHeader.get('basicos.rut').dirty ||
                                    formHeader.get('basicos.rut').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('basicos.rut').hasError('required')">
                    Ingrese rut
                  </mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input placeholder="Giro Comercial" class="form-control" type="text" id="provgirocomercial"
                  formControlName="giro" #provgirocomercial maxLength="100" />
                <label for="provgirocomercial">Giro Comercial
                  <span class="required-asterisk">*</span>
                </label>
                <div *ngIf="
                                    formHeader.get('basicos.giro').invalid &&
                                    (formHeader.get('basicos.giro').dirty ||
                                    formHeader.get('basicos.giro').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('basicos.giro').hasError('required')">
                    Ingrese giro
                  </mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input type="text" id="provrazonsocial" class="form-control" formControlName="nombre"
                  placeholder="Razon Social" maxLength="100" #provrazonsocial />
                <label for="provrazonsocial">Razón Social
                  <span class="required-asterisk">*</span>
                </label>
                <div *ngIf="
                                    formHeader.get('basicos.nombre').invalid &&
                                    (formHeader.get('basicos.nombre').dirty ||
                                    formHeader.get('basicos.nombre').touched)
                                    ">
                  <mdb-error *ngIf="formHeader.get('basicos.nombre').hasError('required')">
                    Ingrese razón social
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>

          <ng-container formGroupName="contacto">
            <div class="row" style="border-bottom: 1px solid #dee2e6;">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">
                  Datos de contacto de proveedor
                </h5>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="Direccion" class="form-control" type="text" id="provdireccion"
                    formControlName="direccion_completa" #provdireccion />
                  <label for="provdireccion">Dirección
                    <span class="required-asterisk">*</span>
                  </label>
                  <div *ngIf="
                                        formHeader.get('contacto.direccion_completa').invalid &&
                                        (formHeader.get('contacto.direccion_completa').dirty ||
                                        formHeader.get('contacto.direccion_completa').touched)
                                        ">
                    <mdb-error *ngIf="formHeader.get('contacto.direccion_completa').hasError('required')">
                      Ingrese dirección
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="md-form">
                  <mdb-select formControlName="region_codigo" [filterEnabled]="true" [options]="optionsRegion"
                    placeholder="Seleccione una Region"></mdb-select>
                  <label>Region
                    <span class="required-asterisk">*</span>
                  </label>
                </div>
                <div class="md-form">
                  <mdb-select formControlName="provincia_codigo" [filterEnabled]="true" [options]="optionsProvincia"
                    placeholder="Seleccione una Provincia">
                  </mdb-select>
                  <label>Provincia
                  </label>
                </div>
                <div class="md-form">
                  <mdb-select formControlName="comuna_codigo" [filterEnabled]="true" [options]="optionsComuna"
                    placeholder="Seleccione una Comuna"></mdb-select>
                  <label>Comuna
                    <span class="required-asterisk">*</span>
                  </label>
                  <div *ngIf="
                                        formHeader.get('contacto.comuna_codigo').invalid &&
                                        (formHeader.get('contacto.comuna_codigo').dirty ||
                                        formHeader.get('contacto.comuna_codigo').touched)
                                    ">
                    <mdb-error *ngIf="formHeader.get('contacto.comuna_codigo').hasError('required')">
                      Ingrese comuna
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input placeholder="Fono1" class="form-control" type="text" id="provtelefono1"
                    formControlName="telefono_principal" #provtelefono1 onlyNumbers />
                  <label for="provtelefono1">Teléfono</label>

                </div>
                <div class="md-form">
                  <input placeholder="Email" class="form-control" type="text" id="provemail"
                    formControlName="mail_contacto" #provemail />
                  <label for="provemail">Email</label>

                </div>
                <div class="md-form">
                  <input placeholder="Contacto" class="form-control" type="text" id="provcontacto"
                    formControlName="nombre_contacto" #provcontacto />
                  <label for="provcontacto">Contacto</label>

                </div>
              </div>
            </div>
          </ng-container>

          <div class="row" style="border-bottom: 1px solid #dee2e6;">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos comerciales
              </h5>
            </div>
          </div>

          <div class="row" formGroupName="comerciales">
            <div class="col">
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input placeholder="Observaciones" class="form-control" type="text" id="provobservaciones"
                      formControlName="observaciones" #provobservaciones />
                    <label for="provobservaciones">Observaciones</label>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select formControlName="condicion_pago_codigo" [filterEnabled]="true"
                      [options]="optionsCondicionPago" placeholder="Seleccione una Condición">
                    </mdb-select>
                    <label>Condición de Pago
                      <span class="required-asterisk">*</span>
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input placeholder="Días" class="form-control" type="text" id="provdiasplazovenc"
                      formControlName="dias_plazo" onlyNumbers #provdiasplazovenc />
                    <label for="provdiasplazovenc">Días de plazo de vencimiento</label>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">

                  <mdb-checkbox formControlName="no_aplica_fec_venc">
                    No aplica fecha de vencimiento al ingresar factura de compra.</mdb-checkbox>

                </div>
                <div class="col">

                  <mdb-checkbox formControlName="es_canje">Proveedor de canje</mdb-checkbox>

                </div>
              </div>

              <div class="row" style="margin-top: 2%;">
                <div class="col">
                  <mdb-checkbox formControlName="tiene_maquina">
                    Habilitar proveedor para maquinas</mdb-checkbox>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="cerrarModal()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button *ngIf="mode === 'ADD'" type="button" class="btn btn-secondary waves-light" mdbWavesEffect
            (click)="create()">
            Guardar
          </button>
          <button *ngIf="mode === 'EDIT'" type="button" class="btn btn-secondary waves-light" mdbWavesEffect
            (click)="update()">
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
